import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import { connect, useDispatch } from 'react-redux';
import { hideAlertDialog } from '../features/ui/redux/uiSlices';
import { RootState } from '../store';

const mapStateToProps = (state: RootState) => ({
    alertDialogProps: state.ui.alertDialog
});

type Props = ReturnType<typeof mapStateToProps>;

const ConfirmDialog = ({ alertDialogProps }: Props) => {
    const dispatch = useDispatch();

    if (alertDialogProps == null) {
        return null;
    }

    const closeClick = () => {
        dispatch(hideAlertDialog());
    };

    const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === 'Escape') {
            closeClick();
            event.preventDefault();
        }
    };

    const getIcon = () => {
        switch (alertDialogProps.icon) {
            case 'info':
                return <InfoIcon />;
            case 'warning':
                return (
                    <WarningIcon
                        style={{
                            fill: '#f5c842'
                        }}
                    />
                );
            case 'error':
                return <ErrorIcon />;
        }
    };

    return (
        <Dialog aria-labelledby="simple-dialog-title" open={true} onKeyDown={onKeyDown}>
            <DialogTitle id="simple-dialog-title">{alertDialogProps.dialogTitle}</DialogTitle>
            <DialogContent>
                <div>
                    {getIcon()}
                    {alertDialogProps.dialogMessage}
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeClick}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default connect(mapStateToProps)(ConfirmDialog);
